
import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { getToken, checkError } from 'src/app/shared/global';
import { CONSTANTES } from "src/app/shared/global";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  public nid: string;
  public password: string;
  public password2: string;
  public mensajeLogin: string;
  public imagenesLogin = CONSTANTES.imagenesLogin;
  public logoDefensa = CONSTANTES.logoDefensa;
  public navImage = CONSTANTES.navBarImage;


  // validación campos formulario
  public formLogin = new FormGroup({
    nid: new FormControl("", [Validators.required]),
    password: new FormControl("", [Validators.required]),
  });

  constructor(private router: Router, private authService: AuthenticationService, 
    private spinner: NgxSpinnerService, private toastr: ToastrService) { }

  ngOnInit() {
    this.spinner.hide();

  }

  checkLogin() {

    this.spinner.show();
    let datos = {
      userName: btoa(this.formLogin.value["nid"]),
      pwd1: btoa(this.formLogin.value["password"]),
      pwd2: btoa(this.formLogin.value["password"])
    }

    this.authService.authenticate(datos).subscribe(
      data => {

        if (getToken(data)) {
          if (data.versionApp === CONSTANTES.version) {
            localStorage.setItem("nid", data.nid);
            localStorage.setItem("firstName", data.firstName);
            localStorage.setItem("lastName", data.lastName);
            localStorage.setItem("phone", data.phone);
            localStorage.setItem("email", data.email);
            localStorage.setItem("role", data.role);
            
            this.router.navigate(['home']);
                        

          } else {
            this.toastr.warning('EXISTE UNA NUEVA VERSIÓN DE LA APP, PARA PODER CONTINUAR DESCARGALA EN AVET WEB');
            this.spinner.hide();
          }

          //this.spinner.hide();
        } else {
          if (data.failed != null && data.errorCode.code === "E_SECURITY_ACCESS_1") {
            this.toastr.warning(data.errorCode.message + " LE QUEDAN " + ((5 - data.failed) > 0 ? (5 - data.failed) : "0") + " INTENTOS PARA QUE SE BLOQUEE SU USUARIO.", "ERROR", {timeOut: 15000});
          } else {
            this.toastr.warning(data.errorCode.message, "ERROR", {timeOut: 30000});
          }
          if (!checkError(data.errorCode.code)) {
            let infoUser = {
              userName: localStorage.getItem("nid")
            }
            this.authService.logOut(infoUser).subscribe(
              data => {
                localStorage.clear();
                this.router.navigate(['login']);
              }
            );
          }

          this.spinner.hide();

        }
      },
      error => {
        this.toastr.error('LOS DATOS DE INICIO DE SESIÓN NO SON CORRECTOS');

        this.spinner.hide();

      });
  }

  forgotUser() {
    this.toastr.info('PARA CONOCER SU USUARIO Y CONTRASEÑA DEBER�? ACCEDER AL PORTAL PERSONAL DE LA INTRANET DEL MINISTERIO DE DEFENSA.');
  }





}
